import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import Results from './Results'

class Search extends React.Component {
    constructor(props) {
        super(props)

        this.state = { text: '', results: null, showResults: false }

        this.ref = React.createRef()

        this.debounceTimeout = null
        this.cancelSource = null
    }

    showResults = () => {
        this.setState({ showResults: true })

        window.document.body.addEventListener('click', this.onClick)
    }

    onClick = e => {
        if (!this.ref.current.contains(e.target)) {
            this.hideResults()
        }
    }

    hideResults = () => {
        this.setState({ showResults: false })

        window.document.body.removeEventListener('click', this.onClick)
    }

    onChange = e => {
        this.setState({ text: e.target.value })

        if (this.cancelSource !== null) {
            this.cancelSource.cancel()
            this.cancelSource = null
        }
        if (this.debounceTimeout !== null) {
            clearTimeout(this.debounceTimeout)
            this.debounceTimeout = null
        }

        if (!e.target.value.trim()) {
            this.hideResults()
            return
        }

        this.debounceTimeout = setTimeout(() => {
            const { text } = this.state

            this.debounceTimeout = null
            this.cancelSource = axios.CancelToken.source()

            this.setState({ results: null })
            this.showResults()

            axios
                .get(`/search/?query=${encodeURIComponent(text)}&limit=5`, { cancelToken: this.cancelSource.token })
                .then(response => {
                    this.cancelSource = null
                    this.setState({ results: response.data })
                })
                .catch(() => (this.cancelSource = null))
        }, 500)
    }

    render() {
        const { collapseContent } = this.props
        const { text, results, showResults } = this.state

        const onLocation = e => {
            this.setState({ text: e })
        }

        return (
            <div className="search" ref={this.ref}>
                <input
                    className="input"
                    placeholder="Start typing APN or address..."
                    value={text}
                    style={{ width: '325px' }}
                    onChange={this.onChange}
                    onFocus={() => {
                        if (this.state.text) {
                            this.showResults()
                        }
                    }}
                />
                {showResults && (
                    <Results
                        results={results}
                        onHide={this.hideResults}
                        onLocation={onLocation}
                        collapseContent={collapseContent}
                    />
                )}
            </div>
        )
    }
}

Search.propTypes = {
    // parent
    collapseContent: PropTypes.func.isRequired
}

export default Search
